var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',[_c('p',{staticClass:"title"},[_vm._v("\n      尊敬的用户\n    ")]),_c('p',{staticClass:"title"},[_vm._v("\n      您已完成实名认证!\n    ")]),_c('van-button',{attrs:{"type":"primary","size":"large","to":"/"}},[_vm._v("\n      前往首页\n    ")])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }